module.exports = __webpack_public_path__ + "img/bg-first-mobile-quarantine.fc346821.png";